import { FC } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Dropdown, Avatar } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { setAuth0UserId } from '@/services/auth0UserStore';
import { useTranslation } from 'react-i18next';
import { handleLogout } from '@/services/axiosClient';

const AuthButton: FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, user, isLoading } = useAuth0();

  if (isAuthenticated && user?.sub) {
    setAuth0UserId(user.sub);
  }

  if (isLoading || !isAuthenticated || !user) {
    return null;
  }

  const getInitials = (name?: string, email?: string) => {
    if (name) {
      const parts = name.split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    }
    if (email) {
      return email.substring(0, 2).toUpperCase();
    }
    return 'U';
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'logout',
      label: t('common.logout'),
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginRight: '16px',
          cursor: 'pointer',
          padding: '4px 8px',
          borderRadius: '4px',
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#f5f5f5';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        <Avatar
          size={32}
          src={user?.picture}
          style={{
            backgroundColor: user?.picture ? undefined : '#722ed1',
            color: '#fff',
            flexShrink: 0,
          }}
        >
          {!user?.picture && getInitials(user?.name, user?.email)}
        </Avatar>
      </div>
    </Dropdown>
  );
};

export default AuthButton;
